<div class="layout-topbar">
    <a href="#/app/main/dashboard" class="layout-topbar-logo">
        <img alt="Logo" id="topbar-logo" src="assets/layout/images/logo-app.png">
    </a>

    <a href="#" class="layout-menu-button" (click)="app.onMenuButtonClick($event)">
        <i class="pi pi-bars"></i>
    </a>

    <span [ngClass]="{ 'layout-topbar-text-light': app.topbarColor == 'layout-topbar-dark', 'layout-topbar-text-dark': app.topbarColor != 'layout-topbar-dark'}" *ngIf="app.currentUser.isImpersonalized">({{l('Impersonalized')}})</span>

    <ul class="layout-topbar-icons">
        <li *ngIf="versionChanged" pTooltip="{{l('App.TopBar.ClickUpdateApp')}}" tooltipPosition="left">
            <a href="#" class="layout-topbar-icon-green" (click)="updateAppVersion()">
                <em class="fa fa-refresh"></em>
            </a>
        </li>

        <!--Agregar icono solo si es tenant 6 (Mexicali)-->
        <li *ngIf="tenantId === 6" class="layout-topbar-notifications" style="position: relative;">
            <!-- Notification Bell Icon -->
            <a href="#" class="layout-topbar-notification-bell" (click)="toggleNotificationsDropdown($event)" 
               style="color: inherit; font-size: 1.2em; position: relative; display: flex; align-items: center; padding: 10px;">
                <i class="pi pi-bell"></i>
                <span *ngIf="unreadNotificationsCount > 0" 
                      class="notification-badge" 
                      style="position: absolute; top: -2px; right: -2px; color: #e74c3c; 
                             font-size: 13px; font-weight: bold; text-shadow: 0 0 3px rgba(255,255,255,0.8);">
                    {{unreadNotificationsCount > 99 ? '99+' : unreadNotificationsCount}}
                </span>
            </a>
            
            <!-- Notifications Dropdown -->
            <div *ngIf="showNotificationsDropdown" 
                 class="notifications-dropdown" 
                 style="position: absolute; top: 100%; right: 0; background: white; border: 1px solid #ddd; 
                        border-radius: 4px; box-shadow: 0 4px 8px rgba(0,0,0,0.1); width: 350px; max-height: 400px; 
                        overflow-y: auto; z-index: 1001;">
                <div style="padding: 10px; border-bottom: 1px solid #eee; font-weight: bold; display: flex; justify-content: space-between; align-items: center;">
                    <span>{{l('ConfiguracionNotificaciones')}} ({{unreadNotificationsCount}})</span>
                    <a href="#" (click)="openNotificationsModal($event)" 
                       style="color: #007bff; text-decoration: none; font-size: 12px; font-weight: normal;">
                        Ver más
                    </a>
                </div>
                <div *ngIf="getUnreadNotifications().length === 0" style="padding: 20px; text-align: center; color: #666;">
                    No hay notificaciones nuevas
                </div>
                <div *ngFor="let notification of getUnreadNotifications()" 
                     class="notification-item" 
                     (click)="markNotificationAsRead(notification, $event)"
                     style="padding: 12px; border-bottom: 1px solid #f0f0f0; cursor: pointer; background: #f8f9fa;">
                    <div style="font-size: 12px; color: #666; margin-bottom: 4px;">
                        {{notification.alertType}} • {{notification.createdAt | date:'short'}}
                        <span style="color: #e74c3c; margin-left: 8px;">●</span>
                    </div>
                    <div style="font-size: 14px; color: #333; line-height: 1.4;" [innerHTML]="notification.message"></div>
                </div>
            </div>
        </li>
    </ul>

    <a href="#" class="layout-topbar-user" (click)="app.onTopbarMenuButtonClick($event)">
        <p-avatar [image]="urlPictureProfile" size="large" shape="circle"></p-avatar>
    </a>

    <ul class="layout-topbar-usermenu" [ngClass]="{'layout-topbar-usermenu-active fadeInDown': app.topbarMenuActive}" style="z-index: 1000 !important;">
        <li class="layout-topbar-usermenu-header">
            <div class="layout-topbar-usermenu-info" style="vertical-align: top !important;">
                <div class="layout-topbar-usermenu-tenant" *ngIf="multiTenancy">{{app.currentUser.tenancyName ? app.currentUser.tenancyName: '&nbsp;'}}</div>
                <div class="layout-topbar-usermenu-name">{{app.currentUser.firstName}}</div>
                <div class="layout-topbar-usermenu-role">{{app.currentUser.lastName  + (app.currentUser.secondLastName ? ' ' + app.currentUser.secondLastName: '')}}</div>
                <div class="layout-topbar-usermenu-role" *ngIf="app.currentUser.isImpersonalized">({{l('Impersonalized')}})</div>
            </div>
        </li>
        <li>
            <a href="#" (click)="app.onTopbarSubItemClick($event)">
                <em class="pi pi-user"></em>
                <span class="topbar-item-name">{{l('App.TopBar.Profile')}}</span>
            </a>
        </li>
        <li *ngIf="app.currentUser.isImpersonalized">
            <a href="#" (click)="app.logoutImpersonalization($event)">
                <em class="fa fa-fw fa-undo"></em>
                <span class="topbar-item-name">{{l('App.TopBar.LogoutImpersonalization')}}</span>
            </a>
        </li>
        <li>
            <a href="#" (click)="app.logout($event)">
                <em class="pi pi-sign-out"></em>
                <span class="topbar-item-name">{{l('App.TopBar.Logout')}}</span>
            </a>
        </li>
    </ul>

    <!-- Modal de Todas las Notificaciones -->
    <p-dialog [(visible)]="showNotificationsModal" 
              [modal]="true" 
              [responsive]="true" 
              [style]="{width: '800px', height: '700px'}"
              [baseZIndex]="10000" 
              [dismissableMask]="true"
              header="Todas las Notificaciones">
        <div class="notifications-modal-content" style="height: 600px; display: flex; flex-direction: column;">
            <!-- Header con filtros -->
            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px; padding-bottom: 10px; border-bottom: 1px solid #eee; flex-shrink: 0;">
                <div style="display: flex; gap: 10px; align-items: center;">
                    <label style="font-weight: bold;">Filtrar:</label>
                    <p-dropdown [options]="notificationFilterOptions" 
                                [(ngModel)]="selectedNotificationFilter" 
                                (onChange)="onNotificationFilterChange()"
                                placeholder="Todas">
                    </p-dropdown>
                </div>
                <div style="color: #666; font-size: 14px;">
                    Total: {{totalNotifications}} notificaciones
                </div>
            </div>

            <!-- Lista de notificaciones con scroll -->
            <div style="flex-grow: 1; overflow-y: auto; margin-bottom: 20px; border: 1px solid #f0f0f0; border-radius: 4px;">
                <div *ngIf="pagedNotifications.length === 0" 
                     style="padding: 40px; text-align: center; color: #666;">
                    <i class="pi pi-bell" style="font-size: 48px; margin-bottom: 16px; opacity: 0.3;"></i>
                    <div>No hay notificaciones para mostrar</div>
                </div>

                <div *ngFor="let notification of pagedNotifications; let i = index" 
                     class="modal-notification-item"
                     style="padding: 16px; cursor: pointer; transition: background-color 0.2s;"
                     [style.background]="!notification.isRead ? '#f8f9fa' : 'white'"
                     [style.border-bottom]="i < pagedNotifications.length - 1 ? '1px solid #f0f0f0' : 'none'"
                     (click)="markNotificationAsRead(notification, $event)"
                     (mouseenter)="$event.currentTarget.style.backgroundColor = '#e9ecef'"
                     (mouseleave)="$event.currentTarget.style.backgroundColor = !notification.isRead ? '#f8f9fa' : 'white'">
                    
                    <div style="display: flex; justify-content: space-between; align-items: start; margin-bottom: 8px;">
                        <div style="display: flex; align-items: center; gap: 8px;">
                            <span style="font-size: 12px; color: #666; font-weight: 500;">{{notification.alertType}}</span>
                            <span *ngIf="!notification.isRead" 
                                  style="background: #e74c3c; color: white; font-size: 10px; padding: 2px 6px; border-radius: 10px;">NUEVA</span>
                        </div>
                        <div style="font-size: 11px; color: #999;">{{notification.createdAt | date:'medium'}}</div>
                    </div>
                    
                    <div style="font-size: 14px; color: #333; line-height: 1.4;" [innerHTML]="notification.message"></div>
                    
                    <div *ngIf="notification.isRead && notification.readedAt" 
                         style="font-size: 11px; color: #28a745; margin-top: 4px;">
                        <i class="pi pi-check" style="margin-right: 4px;"></i>
                        Leída el {{notification.readedAt | date:'short'}}
                    </div>
                </div>
            </div>

            <!-- Paginación siempre visible -->
            <div style="flex-shrink: 0; display: flex; justify-content: center; padding-top: 10px; border-top: 1px solid #eee;">
                <p-paginator 
                    [rows]="notificationsPerPage" 
                    [totalRecords]="totalNotifications" 
                    [first]="currentNotificationPage * notificationsPerPage"
                    (onPageChange)="onNotificationPageChange($event)"
                    [showCurrentPageReport]="true"
                    currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} notificaciones">
                </p-paginator>
            </div>
        </div>
    </p-dialog>

    <!-- <ul class="layout-topbar-icons">

        <li *ngIf="versionChanged" pTooltip="{{l('App.TopBar.ClickUpdateApp')}}" tooltipPosition="left">
            <a href="#" class="layout-topbar-icon-green" (click)="updateAppVersion()">
                <em class="fa fa-refresh"></em>
            </a>
        </li>
    </ul> -->
</div>
